import $ from 'jquery'
import LazyLoad from "vanilla-lazyload";
import CategoryAndTagHeader from "./widgets/category-and-tag-header"
import Ranking from "./widgets/ranking";
import WCookies from "./widgets/cookies";
import Header from "./widgets/header"
import VueHeader from "./widgets/vue-header"
import domEvents from "./modules/dom-events";
import LoginButton from "./modules/login-button";
import VideoConsultas from "./widgets/video-consultas";
import AccountComplete from "./widgets/account-complete";

const lazyLoad = new LazyLoad({'elements_selector': 'img'});
const header = new Header();
VueHeader.init();
domEvents.init();

$('[data-id="category_and_tag_header"]').each(function () {
    new CategoryAndTagHeader(this);
});

$('[data-id="c-ranking"]').each(function () {
    new Ranking(this);
});

$('[data-cookies-container]').each(function () {
    new WCookies(this);
});

$('[data-login-show]').each(function(){
    const loginButton = new LoginButton(this);
});

$('[data-account_complete-container]').each(function () {
    new AccountComplete(this);
});

new VideoConsultas($('[data-id="video-consulta-render"]'));